import { GET_DMX_DEVICE_PRESETS, GET_DMX_DEVICE_PRESETS_SUCCESS, GET_DMX_DEVICE_PRESETS_ERROR } from './actionTypes';

export const getDmxDevicePresets = (user, deviceId) => {
  return {
    type: GET_DMX_DEVICE_PRESETS,
    payload: { user, deviceId },
  };
};

export const getDmxDevicePresetsSuccess = (presets) => {
  return {
    type: GET_DMX_DEVICE_PRESETS_SUCCESS,
    payload: { presets },
  };
};

export const getDmxDevicePresetsError = (error) => {
  return {
    type: GET_DMX_DEVICE_PRESETS_ERROR,
    payload: error,
  };
};
